import script from "./jdDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./jdDetails.vue?vue&type=script&setup=true&lang=js"

import "./jdDetails.vue?vue&type=style&index=0&id=42f88a40&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42f88a40"]])

export default __exports__